export default __webpack_public_path__ + "a3acaacfeeeff6c8ee00e35366dd5dde.svg";